export const BID_MERCHANT_CREATE_MERCHANT = "BID_MERCHANT_CREATE_MERCHANT"